module.exports = __webpack_public_path__ + "static/media/ic_diners.002067ed.svg";